import Stack from "@mui/material/Stack";
import JimpiFilters from "./jimpi/JimpiFilters";
import JimpiTable from "./jimpi/JimpiTable";

export const JimpiTabPanel = () => {

    return (
        <>
            <Stack rowGap={3} >
                <JimpiFilters />
                <JimpiTable />
            </Stack>
        </>
    );
};

export default JimpiTabPanel;
